
import { defineComponent } from 'vue';
import { 
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, 
  IonButtons, IonMenuButton, IonIcon, IonButton, IonSpinner, toastController, alertController
} from '@ionic/vue';
import { 
  refreshOutline, notificationsOutline, arrowForwardOutline, locationOutline,
  closeOutline, checkmarkOutline, checkmarkDoneCircleOutline
} from 'ionicons/icons';
import { pushFocus } from '../../pushNotifications';

export default defineComponent({
  name: 'ManualAttendanceApprovals',
  mixins: [pushFocus],
  components: {
    IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
    IonButtons, IonMenuButton, IonIcon, IonButton, IonSpinner
  },
  setup() {
    return {
      refreshOutline, notificationsOutline, arrowForwardOutline, locationOutline,
      closeOutline, checkmarkOutline, checkmarkDoneCircleOutline
    }
  },
  data() {
    return {
      pendingList: [] as any[],
      loading: false
    }
  },
  mounted() {
    this.fetchPendingApprovals();
  },
  methods: {
    reloadForPush() {
      this.fetchPendingApprovals();
    },
    getInitials(name: string) {
      if (!name) return 'U';
      const parts = name.split(' ');
      if (parts.length > 1) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name[0].toUpperCase();
    },
    async fetchPendingApprovals() {
      this.loading = true;
      const data = {
        username: window.localStorage.username,
        password: window.localStorage.password,
      };
      
      this.$http.post('hr/pendingManualAttendanceApprovals', data, { skipLoading: true })
        .then(response => {
          if (response.data.status) {
            this.pendingList = response.data.pending || response.data.data || [];
          }
          this.loading = false;
          // Opened from a notification: show that request.
          this.focusPushCard('This attendance request has already been handled.');
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async promptDecline(id: number) {
      const alert = await alertController.create({
        header: 'Decline Request',
        message: 'Are you sure you want to decline this checkout request?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel'
          },
          {
            text: 'Yes, Decline',
            handler: () => {
              this.decline(id);
            }
          }
        ]
      });
      await alert.present();
    },
    async approve(id: number) {
      this.loading = true;
      const data = {
        username: window.localStorage.username,
        password: window.localStorage.password,
        request_id: id
      };

      this.$http.post('hr/approveManualAttendanceRequest', data)
        .then(async (response) => {
          if (response.data.status) {
            const toast = await toastController.create({
              message: 'Request approved successfully.',
              duration: 2000,
              color: 'success'
            });
            toast.present();
            this.fetchPendingApprovals();
          } else {
            this.loading = false;
            const toast = await toastController.create({
              message: response.data.message || 'Approval failed.',
              duration: 3000,
              color: 'danger'
            });
            toast.present();
          }
        })
        .catch(async () => {
          this.loading = false;
        });
    },
    async decline(id: number) {
      this.loading = true;
      const data = {
        username: window.localStorage.username,
        password: window.localStorage.password,
        request_id: id
      };

      this.$http.post('hr/declineManualAttendanceRequest', data)
        .then(async (response) => {
          if (response.data.status) {
            const toast = await toastController.create({
              message: 'Request declined.',
              duration: 2000,
              color: 'medium'
            });
            toast.present();
            this.fetchPendingApprovals();
          } else {
            this.loading = false;
          }
        })
        .catch(async () => {
          this.loading = false;
        });
    }
  }
});
